<div class="spc-container">
  <sh-card label="Spare Parts Catalog">
    <div class="content">
      <sh-text size="header-2">{{ title }}</sh-text>
      <sh-divider spacing="m"></sh-divider>
      
      <!-- Search and Filter Section -->
      <div class="search-section">
        <div class="search-filters">
          <div class="filter-row">
            <div class="filter-item">
              <sh-input-text 
                id="searchQuery"
                label="Search Query"
                [value]="searchQuery"
                (input)="searchQuery = $any($event.target).value"
                placeholder="Enter search term..."
                (keyup.enter)="onSearch()"> 
              </sh-input-text>
            </div>
          </div>
          
          <div class="filter-row">
            <div class="filter-item">
              <sh-input-text 
                id="bookCode"
                label="Book Code"
                [value]="bookCode"
                (input)="bookCode = $any($event.target).value"
                placeholder="e.g., CT0000"
                (keyup.enter)="onSearch()">
              </sh-input-text>
            </div>
            
            <div class="filter-item">
              <sh-input-text 
                id="pageReference"
                label="Page Reference"
                [value]="pageReference"
                (input)="pageReference = $any($event.target).value"
                placeholder="e.g., 10496999"
                (keyup.enter)="onSearch()">
              </sh-input-text>
            </div>
            
            <div class="filter-item">
              <sh-input-text 
                id="partNumber"
                label="Part Number"
                [value]="partNumber"
                (input)="partNumber = $any($event.target).value"
                placeholder="e.g., 03074523"
                (keyup.enter)="onSearch()">
              </sh-input-text>
            </div>
          </div>
          
          <div class="action-buttons">
            <sh-button variant="primary" label="Search" (click)="onSearch()">
            </sh-button>
            <sh-button variant="secondary" label="Clear Filters" (click)="clearFilters()">
            </sh-button>
          </div>
        </div>
      </div>

      <sh-divider spacing="m"></sh-divider>

      <!-- Loading Spinner -->
      <div *ngIf="isLoading" class="loading-container">
        <sh-spinner size="large"></sh-spinner>
        <sh-text size="body-1">Searching spare parts...</sh-text>
      </div>

      <!-- Error Message -->
      <div *ngIf="errorMessage" class="error-message">
        <sh-text size="body-1" class="error-text">{{ errorMessage }}</sh-text>
      </div>

      <!-- Results Section -->
      <div *ngIf="!isLoading && hasSearched && !errorMessage" class="results-section">
        <div class="results-header">
          <sh-text size="header-3">
            Showing {{ displayRange }} of {{ filteredSpareParts.length }} spare part(s)
          </sh-text>
          <sh-text size="body-2" class="page-info">
            Page {{ currentPage }} of {{ totalPages }}
          </sh-text>
        </div>

        <!-- No Results -->
        <div *ngIf="filteredSpareParts.length === 0" class="no-results">
          <sh-text size="body-1">No spare parts found matching your criteria.</sh-text>
        </div>

        <!-- Results Grid -->
        <div *ngIf="filteredSpareParts.length > 0" class="results-grid">
          <div *ngFor="let part of paginatedResults" class="spare-part-card">
            <div class="part-image">
              <!-- Loading spinner -->
              <div *ngIf="part.imageLoading" class="image-loading">
                <sh-spinner size="medium"></sh-spinner>
              </div>
              <!-- Loaded image -->
              <img 
                *ngIf="!part.imageLoading && hasImage(part)" 
                [src]="part.image_sas_url" 
                [alt]="part.description"
                class="part-img"
                (error)="onImageError(part)">
              <!-- No image available -->
              <div *ngIf="!part.imageLoading && !hasImage(part)" class="no-image">
                <sh-text size="body-2">No Image Available</sh-text>
              </div>
            </div>
            
            <div class="part-details">
              <div class="part-header">
                <sh-text size="header-4" class="part-number">
                  {{ part.part_number }}
                </sh-text>
                <!-- <sh-text size="body-2" class="item-id">
                  Item #{{ part.item_id }}
                </sh-text> -->
              </div>
              
              <sh-text size="body-1" class="part-description">
                {{ part.description }}
              </sh-text>
              
              <div class="part-metadata">
                <div class="metadata-item">
                  <sh-text size="caption" class="metadata-label">Book Code:</sh-text>
                  <sh-text size="body-2">{{ part.book_code }}</sh-text>
                </div>
                <div class="metadata-item">
                  <sh-text size="caption" class="metadata-label">Page Ref:</sh-text>
                  <sh-text size="body-2">{{ part.page_reference }}</sh-text>
                </div>
                <div class="metadata-item">
                  <sh-text size="caption" class="metadata-label">Quantity:</sh-text>
                  <sh-text size="body-2">{{ part.quantity }}</sh-text>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Pagination -->
        <div *ngIf="filteredSpareParts.length > 0" class="pagination">
          <sh-button 
            variant="secondary" 
            label="Previous"
            [disabled]="currentPage === 1"
            (click)="previousPage()">
          </sh-button>
          
          <div class="page-numbers">
            <sh-text size="body-1" class="page-indicator">
              Page {{ currentPage }} of {{ totalPages }}
            </sh-text>
            <sh-text size="body-2" class="results-count">
              ({{ filteredSpareParts.length }} results)
            </sh-text>
          </div>
          
          <sh-button 
            variant="secondary" 
            label="Next"
            [disabled]="currentPage >= totalPages"
            (click)="nextPage()">
          </sh-button>
        </div>
      </div>
    </div>
  </sh-card>
</div>
